import { gsap, ScrollTrigger, ScrollToPlugin } from "gsap/all";
import { BREAKPOINTS } from "../styles/variables/breakpoints";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
}

const parallax = (target, number, enableOnMobile = false) => {
  if (typeof window === "undefined" || !target) return;

  const mm = gsap.matchMedia();

  mm.add(`(min-width: ${BREAKPOINTS.sm}px)`, () => {
    gsap.fromTo(
      target,
      { yPercent: -number },
      {
        yPercent: number,
        ease: "none",
        scrollTrigger: {
          trigger: target,
          scrub: 1,
        },
      }
    );
  });

  if (enableOnMobile) {
    mm.add(`(max-width: ${BREAKPOINTS.sm - 1}px)`, () => {
      gsap.fromTo(
        target,
        { yPercent: -number },
        {
          yPercent: number,
          ease: "none",
          scrollTrigger: {
            trigger: target,
            scrub: 1,
          },
        }
      );
    });
  }
  return mm;
};

const animations = {
  ...(typeof window !== "undefined" ? gsap : {}),
  ScrollTrigger: typeof window !== "undefined" ? ScrollTrigger : undefined,
  ScrollToPlugin: typeof window !== "undefined" ? ScrollToPlugin : undefined,
  parallax,
};

export default animations;
